import { defineStore } from 'pinia'

export default defineStore({
  id: 'vehicleDataTable',
  persist: true,
  state: () => {
    return {
      columnState: [],
      isVehicleCategoryArchive: false,
      isVehicleArchive: false,
      isVehicleRemoocArchive: false,
      isVehicleRemoocDocumentArchive: false,
      isVehicleRemoocCategoryArchive: false,
      isVehicleDocumentArchive: false,
      isVehicleRepairArchive: false
    }
  },
  actions: {
    setColumnVehicleState: function (payload: any) {
      this.columnState = payload
    },
    setIsVehicleCategoryArchive: function (payload: any) {
      this.isVehicleCategoryArchive = payload
    },
    setIsVehicleArchive: function (payload: any) {
      this.isVehicleArchive = payload
    },
    setIsVehicleRemoocArchive: function (payload: any) {
      this.isVehicleRemoocArchive = payload
    },
    setIsVehicleRemoocDocumentArchive: function (payload: any) {
      this.isVehicleRemoocDocumentArchive = payload
    },
    setIsVehicleRemoocCategoryArchive: function (payload: any) {
      this.isVehicleRemoocCategoryArchive = payload
    },
    setIsVehicleDocumentArchive: function (payload: any) {
      this.isVehicleDocumentArchive = payload
    },
    setIsVehicleRepairArchive: function (payload: any) {
      this.isVehicleRepairArchive = payload
    }
  },
  getters: {
    getColumnVehicleState: (state: any) => state.columnState,
    getIsVehicleCategoryArchive: (state: any) => state.isVehicleCategoryArchive,
    getIsVehicleArchive: (state: any) => state.isVehicleArchive,
    getIsVehicleRemoocArchive: (state: any) => state.isVehicleRemoocArchive,
    getIsVehicleRemoocDocumentArchive: (state: any) => state.isVehicleRemoocDocumentArchive,
    getIsVehicleRemoocCategoryArchive: (state: any) => state.isVehicleRemoocCategoryArchive,
    getIsVehicleDocumentArchive: (state: any) => state.isVehicleDocumentArchive,
    getIsVehicleRepairArchive: (state: any) => state.isVehicleRepairArchive
  }
})
